var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"echart",staticClass:"w-full min-h-400"})}
var staticRenderFns = []

export { render, staticRenderFns }